import {
  Box,
  Tab,
  Tabs,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  InputAdornment,
  Container,
} from "@mui/material";
import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

// import Heading from "../../components/Heading";
// import { GadgetsProtectionStyles } from "./Styles";

// import GlobalBanner from "../../components/GlobalBanner";
// import { BNRS, GDGTSPRTCN } from "../../constants/AssetsPath";
// import GlobalSubHeading from "../../components/GlobalSubHeading";
// import { HOMEAPPLIANCEPLANS, MOBILEPLANS } from "../../utils/Json";
import MBLGDTSBNR from "../assets/Banner/WebBanner/MobileGadgets.png";
import HMEAPLNCGDTSBNR from "../assets/Banner/WebBanner/HomeAppliance.png";
import TestimonialCard from "../components/HomeAppliances/TestimonialCard";
import VideoTestimonial from "../components/HomeAppliances/VideoTestimonial";
import StepCard from "../components/HomeAppliances/StepCard";
import PlanCard from "../components/HomeAppliances/PlanCard";
import RatingCard from "../components/HomeAppliances/RatingCard";

import BLGBCKGRND from "../assets/images/Home/Blog.png";

// Banner
import TRVLASTNCBNR from "../assets/Banner/WebBanner/TravelAssistance.png";
import AUTOMOTIVEASTNCBNR from "../assets/Banner/WebBanner/AutomotiveAssistance.png";
// import MBLGDTSBNR from "../assets/Banner/WebBanner/MobileGadgets.png";
// import HMEAPLNCGDTSBNR from "../assets/Banner/WebBanner/HomeAppliance.png";
import HMEASTNCBNR from "../assets/Banner/WebBanner/HomeAssistance.png";
import INCMTRTCTBNR from "../assets/Banner/WebBanner/IncomeProtect.png";
import TRVLMDCLBNR from "../assets/Banner/WebBanner/TravelMedical.png";
import CYBRSCRTYBNR from "../assets/Banner/WebBanner/CyberSecurity.png";
import CAREERBANERS from "../assets/Banner/WebBanner/CareerBanner.png";
import BECOMEPARTNER from "../assets/Banner/WebBanner/BecomePartnerBanner.png";
import PRIVACYPOLICY from "../assets/Banner/WebBanner/PrivacyPolicyBanner.png";
import TNC from "../assets/Banner/WebBanner/TnCBanner.png";
import OUTPRODUCTS from "../assets/Banner/WebBanner/OurProducts.png";
import Header from "../layout/Header";
// import banner1 from "../assets/Banner/WebBanner/b2.png";
import banner1 from "../assets/Banner/WebBanner/HD appliance.png";

import logo from "../assets/images/About/about-logo.png";
import HeroSection from "../components/HeroSection";
import BannerContent from "../components/BannerContent";
import HassleFree from "../components/HomeAppliances/hasslefree";
import { IntroProductSection } from "../components/introProductSection";

import productImage from "../assets/images/Home/home-app.jpg";
import location from "../assets/images/Automobile/customer-care.gif";
import contact from "../assets/images/Automobile/like.gif";
import rsafleet from "../assets/images/Automobile/fleet-supervisor.gif";
import HowItWorksAutomobileFlow from "../components/AutomobileAssistance/HowItWorks";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import FAQ from "../components/FAQ";
import NewsLetter from "../components/Home/NewsLetter";

// services images
import protection from "../assets/images/Home/disaster.png";
import homeSecurity from "../assets/images/Home/local.png";
import amc from "../assets/images/Home/renovation.png";
import RSA from "../components/AutomobileAssistance/RSA";

// import mobile from '../assets/Banner/WebBanner/MobileGadgets.png';
// import mobilee from '../';

const FeatureItem = ({ text }) => (
  <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.6 }}>
    <CheckCircleIcon color="success" sx={{ fontSize: 18 }} />
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        textAlign: "left",
        fontFamily: 'Poppins", serif',
        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.98rem" },
      }}
    >
      {text}
    </Typography>
  </Stack>
);
const Stat = ({ icon, label, sub }) => (
  <Stack alignItems="center">
    {icon}
    <Typography
      variant="h6"
      fontWeight={700}
      sx={{ fontFamily: '"Poppins", serif' }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ fontFamily: '"Poppins", serif' }}
    >
      {sub}
    </Typography>
  </Stack>
);

const HomeAppliances = () => {
  const [formData, setFormData] = useState({
    brand: "",
    purchaseDate: "",
    amount: "",
  });

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const MOBILEPLANS = [
    {
      title: "One-Time Screen Replacement",
      customers: "Chosen by 90,796 customers in last 30 days",
      features: [
        "Accidents happen — we've got you covered. If your device screen gets damaged, we'll replace it once at no extra cost.",
        "Available for both new and existing devices.",
        "Available for both new and existing devices.",
      ],
      image: "/path/to/image1.png", // Replace with actual path
    },
    {
      title: "Extended Warranty",
      customers: "Chosen by 59,760 customers in last 30 days",
      features: [
        // "Enjoy peace of mind beyond the standard warranty. We cover your device against all kinds of malfunction issues — from speaker problems to general hardware and software repairs. ",
        "Enjoy peace of mind beyond the standard warranty. We cover your device against all kinds of malfunction issues.",
        "Reliable support whenever you need it. ",
        "Reliable support whenever you need it. ",
      ],
      image: "/path/to/image2.png",
    },
    {
      title: "Accidental & Liquid Damage",
      customers: "Chosen by 30,760 customers in last 30 days",
      features: [
        "Life is unpredictable, but your device protection doesn’t have to be. We cover repair costs for accidental drops and spills. Whether it’s a cracked screen from a fall or damage from liquid.",
        "Full coverage for future mishaps.",
        "Full coverage for future mishaps. Reliable support whenever you need it.",
      ],
      image: "/path/to/image3.png",
      isNew: true,
    },
  ];

  // Refined feature points - with concise, value-focused description
  const points = [
    {
      icon: location,
      title: "10 years of expertise",
    },
    {
      icon: contact,
      title: "5 Million+ Happy Customers",
    },
    {
      icon: rsafleet,
      title: "India’s Largest RSA Fleet",
    },
  ];

  const propsData = {
    imageSrc: productImage,
    altText: "Automobile Assistance Across Assist",
    heading: "Trust Only the Best for Protecting What Powers Your Home ", // Note: Use \n for line breaks in JSX
    description:
      " From your air conditioner to your washing machine, your appliances work hard every day. With Across Assist, ensure they’re protected against wear, accidents and unexpected breakdowns with plans that are quick, convenient and great value for money. ",
    points,
  };

  const FAQdata = [
    {
      question:
        "What types of appliances are covered under Across Assist’s protection plans?",
      answer:
        "We cover a wide range of home appliances including air conditioners, washing machines, refrigerators, water purifiers, and more. You can choose between Damage Protection, Extended Warranty, or Annual Maintenance Contracts (AMC) based on your needs.",
    },
    {
      question:
        "How is Across Assist different from regular appliance service providers?",
      answer:
        "Across Assist offers doorstep service by certified technicians, minimal documentation, and fast claims. Our plans also include liquid damage protection, scheduled maintenance, and extended warranty coverage—all designed for convenience and peace of mind.",
    },
    {
      question: "What happens if my appliance breaks down unexpectedly?",
      answer:
        "Just raise a request via call or email. Our team will guide you instantly, and a certified technician will visit your home for quick, hassle-free service. Repairs are done professionally with no hidden charges.",
    },
    {
      question:
        "Can I buy protection for appliances that are already out of warranty?",
      answer:
        "Yes! Our Extended Warranty and AMC plans are designed to cover appliances beyond the manufacturer’s warranty period. You’ll get coverage for key components and preventive maintenance to avoid costly breakdowns.",
    },
  ];
  const CARDS = [
    { icon: protection, title: "Damage Protection Plan" },
    { icon: homeSecurity, title: "Extended Warranty" },
    { icon: amc, title: "Annual Maintenance Contract" },
  ];

  const propsServicesData = {
    heading: "Our Services",
    cards: CARDS,
  };
  return (
    <>
      <>
        <BannerContent
          mb={7}
          bannerImage={banner1}
          title="Home Appliances Assurance "
          subtitle=" Secure your home’s essentials—effortlessly."
          containerStyles={{ background: "none" }}
          bannerHeight="400px"
        />
        {/* <HeroSection
          bannerImage={banner1}
          heading="Protect Your Home Appliances, Live Worry-Free"
          description="Get comprehensive protection plans for your home appliances. Safeguard against accidental damage, liquid spills, and extend your appliance's warranty with our trusted services. Join thousands of happy customers who trust us to keep their appliances running like new!"
          image={logo}
          gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
          gradientOpacity={0.9}
        /> */}
        <Box className="mt-4">
          <IntroProductSection {...propsData} />
        </Box>
        <Box className="py-4 my-1">
          <RSA {...propsServicesData} />
        </Box>

        <Box
          sx={{
            // background: "#fff6f1",
            marginTop: "0px",
          }}
        >
          {/* <Container maxWidth="lg">
            <Grid
              py={3}
              container
              spacing={4}
              display="flex"
              alignItems="center"
              justifyContent="space-around"
              sx={{
                mt: { xs: 3, sm: 3, md: 0, lg: 0 },
                // padding: "0px 20px",
                background: "#fff6f1",
              }}
            >
              <Grid item xs={12} md={5} sx={{ width: "450px" }}>
                <Box>
                 
                  <Typography variant="h4">
                    Trust only the best for Protecting your Mobiles
                  </Typography>
                 
                </Box>

                <Stack spacing={0} mt={3}>
                  <FeatureItem text="Protection from damages, liquid spills and defects" />
                  <FeatureItem text="Mobile protection plans start at only Rs.3/day*" />
                  <FeatureItem text="100% genuine service. 0% hassle" />
                </Stack>

                <Stack direction="row" spacing={6} mt={4}>
                  <Stat
                    icon={<EmojiEventsIcon color="primary" />}
                    label="10 years"
                    sub="of expertise"
                  />
                  <Stat
                    icon={<EmojiEmotionsIcon color="primary" />}
                    label="5 Million+"
                    sub="Happy Customers"
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={7} sx={{ width: "400px" }}>
                <Box
                  sx={{
                    p: 3,
                    boxShadow: 0,
                    border: "1px solid #d2d1d1ff",
                    borderRadius: 2,
                    backgroundColor: "#fff6f1",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={2}
                    textAlign="left"
                    fontFamily='"Poppins", serif'
                  >
                    Find plans for your device
                  </Typography>

                  <Stack spacing={2}>
                    <TextField
                      fullWidth
                      label="Device Brand"
                      variant="outlined"
                      name="brand"
                      value={formData.brand}
                      onChange={handleChange}
                    />

                    <TextField
                      fullWidth
                      label="Purchase date"
                      variant="outlined"
                      name="purchaseDate"
                      value={formData.purchaseDate}
                      onChange={handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <TextField
                      fullWidth
                      label="How much did you purchase it for?"
                      variant="outlined"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                    />

                    <Button
                      variant="contained"
                      size="medium"
                     
                    >
                      Find Plans
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Container> */}

          {/* ****** Plan Card Container *******/}
          {/* <Box
            py={5}
            textAlign="center"
            sx={{
              bgcolor: "white",
            }}
          >
            <Container maxWidth="lg">
              <Box textAlign="center">
                <Typography variant="h4">
                  Let's find you the best plan
                </Typography>
              </Box>

              <Box
                textAlign="center"
                mt={{
                  xs: "0.7rem",
                  sm: "0.7rem",
                  md: "0.7rem",
                  lg: "0.7rem",
                }}
              >
                <Typography variant="h6">
                  Quick. Convenient. Best value-for-money protection plan.
                </Typography>
              </Box>

              <Box
                py={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Grid container spacing={2}>
                  {MOBILEPLANS.map((plan, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <PlanCard {...plan} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Container>
          </Box> */}

          {/* ****** Claim Container *******/}
          <HassleFree />

          {/* ****** Rating Section ****** */}
          {/* <Box align="center" py={5} sx={{ bgcolor: "white" }}>
            <Box align="center">
              <Typography variant="h4">
                Everything that we do is designed around you
              </Typography>
            </Box>
            <RatingCard />

            <Grid container spacing={4} py={3}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <VideoTestimonial />
              </Grid>
            </Grid>

            <Grid mt={1.5} mb={1.5} item xs={12} sm={12} md={4}>
              <Grid
                container
                spacing={2}
                sx={[
                  {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    width: { xs: 335, sm: 335, md: "100%" },
                  },
                ]}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Manya.png")}
                    name="Manya"
                    rating={4}
                    review="Quick claim, impressive service. Grateful for prompt support!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Shivani.png")}
                    name="Shivani"
                    rating={5}
                    review="Swift claim, excellent service, highly recommended!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Ankur.jpeg")}
                    name="Ankur"
                    rating={5}
                    review="Hassle-free insurance process, professional handling!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    initials="AK"
                    name="Akash"
                    rating={5}
                    review="Phone restored, very satisfied, highly recommended!"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box> */}
        </Box>

        

        {/* <HowItWorksAutomobileFlow /> */}
        <CustomerReviews />

        <FAQ FAQdata={FAQdata} />

        <NewsLetter />
      </>
    </>
  );
};

export default HomeAppliances;

// const styles = {
//     BackgroundBox: (blogBackground) => ({
//         backgroundImage: `url(${blogBackground})`,
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//     }),
//     TabStyle: {
//         fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
//         fontFamily: '"Poppins", serif',
//     },
//     HeadingTypography: {
//         textAlign: "left",
//         fontFamily: '"Poppins", serif',
//         fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.5rem" },
//     },
//     UnderlinedText: {
//         color: "#333",
//         textDecoration: "underline",
//         textDecorationColor: "#2196f3",
//         fontFamily: '"Poppins", serif',
//     },
//     TextFieldStyle: {
//         "& .MuiInputBase-input": {
//             fontFamily: '"Poppins", serif',
//             fontSize: "0.9rem",
//             height: "50px",
//             boxSizing: "border-box",
//         },
//         "& .MuiInputLabel-root": {
//             fontFamily: '"Poppins", serif',
//             fontSize: "0.9rem",
//         },
//     },
//     FindPlansButton: {
//         mt: 2,
//         fontFamily: '"Poppins", serif',
//         color: 'white',
//         background: 'black',
//         maxWidth: '8rem',
//         float: 'right',

//     },
//     CenteredBox: {
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//     },
//     PlanHeading: {
//         fontFamily: '"Poppins", serif',
//         fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.8rem" },
//     },
//     SubHeading: {
//         fontFamily: '"Poppins", serif',
//         fontSize: { xs: "1rem", sm: "1rem", md: "1.2rem" },
//     },
//     GridCentered: {
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: "100%",
//     },
//     RightSectionBox: {
//         p: 4,
//         boxShadow: 3,
//         borderRadius: 2,
//         backgroundColor: "white",
//     },
//     RightSectionHeading: {
//         fontFamily: '"Poppins", serif',
//         fontWeight: 600,
//         mb: 3,
//         textAlign: "left",
//     },
// };
